import Vue from 'vue'
import Router from 'vue-router'
import Home from "../views/Home"
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: function () {
      return import('../views/About.vue')
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: function () {
      return import('../views/Product.vue')
    }
  },
  {
    path: '/IndustryCase',
    name: 'IndustryCase',
    component: function () {
      return import('../views/IndustryCase.vue')
    }
  },
  {
    path: '/ContactUs',
    name: 'ContactUs',
    component: function () {
      return import('../views/ContactUs.vue')
    }
  },
  {
    path: '/News',
    name: 'News',
    component: function () {
      return import('../views/News.vue')
    }
  },
  {
    path: '/ProductDetails',
    name: 'ProductDetails',
    component: function () {
      return import('../views/ProductDetails.vue')
    }
  },
  {
    path: '/NewsDetails',
    name: 'NewsDetails',
    component: function () {
      return import('../views/NewsDetails.vue')
    }
  },
  {
    path: '/IndustryCaseDetails',
    name: 'IndustryCaseDetails',
    component: function () {
      return import('../views/IndustryCaseDetails.vue')
    }
  },
  {
    path: '/LogisticsList',
    name: 'LogisticsList',
    component: function () {
      return import('../views/LogisticsList.vue')
    }
  }
]

const router = new Router({
  // mode: 'history',
  scrollBehavior(to,from,saveTop){

    if(saveTop){
    
    return saveTop;
    
    }else{
    
    return {x:0,y:0}
    
    } },
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js